const BASE_URL = 'https://aptest.hakaru-rakusuru.jp/v1'; // 検証環境API

export default BASE_URL;
